import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useUser } from './UserContext';
import Login from './Login';
import Register from './Register';
import Dashboard from './Dashboard';
import PatientActivation from './patient-activation';
import SetPassword from './SetPassword';
import Translate from './Translate';
import Scanner from './Orders/Scanner.js';
import Filetransfer from './filetransfer/Filetransfer.js';
import PrivacyPolicy from './PrivacyPolicy';
import OncoriskDashboard from './PlatformTools/Oncology/OncologyLanding';
import GeneriskDashboard from './PlatformTools/Generiskpro/GRLanding';
import ReportView from './ReportViewer/ReportView';
import { UserProvider } from './UserContext';
import OncoRisk from './WebServer/OncoRisk/oncorisk.js';
import GeneRisk from './WebServer/Generisk/wsgenerisk.js';
import FamilyRisk from './WebServer/FamilyRisk/FamilyRisk.js';
import GVEP from './WebServer/GVEP/GVEP.js';
import GPolygenesis from './WebServer/GPolygenesis/GPolygenesis.js';
import GAtlas from './WebServer/GAtlas/GAtlas.js';
import PolyGen from './WebServer/PolyGen/PolyGen.js';
import WBT from './WebServer/WBT/WBT.js';
import ProteoRisk from './WebServer/ProteoRisk/ProteoRisk.js';
import ProteoRiskAbout from './WebServer/ProteoRisk/ProteoRiskAbout.js';

import HPA from './HPAGFrontend/HPA.js';
import AdminAnalytics from './HPAGFrontend/AdminAnalytics.js';

import NewGenome from './WebServer/NewGenome/NewGenome.js';
import UltimateHome from './UltimateHome/UltimateHome.js';
import OmicAtlas from './OmicsAtlas/OmicAtlas.js';
import Monad from './MONAD/App';
import AnalyticsPlatform from './Analytics/AnalyticsPlatform.js';
import Xomics from './xomics/Xomics.js';
import Clinician from './clinician/clinician.js';

// Import about page components
import GeneRiskAbout from './UltimateHome/components/about/GeneRiskAbout.js';
import FamilyRiskAbout from './UltimateHome/components/about/FamilyRiskAbout.js';
import OncoRiskAbout from './UltimateHome/components/about/OncoRiskAbout.js';
import VarXOmicsAbout from './UltimateHome/components/about/VarXOmicsAbout.js';
import GVEPAbout from './UltimateHome/components/about/GVEPAbout.js';
import MobileAppAbout from './UltimateHome/components/about/MobileAppAbout.js';
import Meeting from './clinician/Meeting.js'; // <--- IMPORT THE NEW COMPONENT

// Kits are activated on the store's own page, which records them in XOmics. The old page here wrote to the old
// system, so the new app never saw those kits.
const KIT_ACTIVATION_URL = 'https://phenomelongevity.com/account/activate/start/';

function ExternalRedirect({ to }) {
    React.useEffect(() => {
        window.location.replace(to);
    }, [to]);
    return null;
}

function App() {
    return (
        <UserProvider>
            <Router>
                <Routes>
                    {/* Public routes */}
                    <Route path="/" element={<UltimateHome />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/oncorisk" element={<OncoRisk />} />
                    <Route path="/varxomics" element={<NewGenome />} />
                    <Route path="/gvep" element={<GVEP />} />
                    <Route path="/gpolygenesis" element={<GPolygenesis />} />
                    <Route path="/ggwas" element={<GAtlas />} />
                    <Route path="/gpgs" element={<PolyGen />} />
                    <Route path="/wbtrisk" element={<WBT />} />
                    <Route path="/wbt" element={<Navigate to="/wbtrisk" replace />} />
                    <Route path="/proteorisk/*" element={<ProteoRisk />} />

                    <Route path="/familyrisk" element={<FamilyRisk />} />

                    <Route path="/genriskpro" element={<GeneRisk />} />
                    <Route path="/babygenepro" element={<GeneriskDashboard />} />
                    <Route path="/hpa" element={<HPA />} />
                    <Route path="/hpa-admin" element={<AdminAnalytics />} />
                    <Route path="/analytics" element={<AnalyticsPlatform />} />

                    {/* About page routes */}
                    <Route path="/xomics/*" element={<Xomics />} />
                    <Route path="/clinicportal/*" element={
                        <ProtectedRoute>
                            <Clinician />
                        </ProtectedRoute>
                    } />
                    <Route path="/genriskpro/about" element={<GeneRiskAbout />} />
                    <Route path="/familyrisk/about" element={<FamilyRiskAbout />} />
                    <Route path="/oncorisk/about" element={<OncoRiskAbout />} />
                    <Route path="/varxomics/about" element={<VarXOmicsAbout />} />
                    <Route path="/gvep/about" element={<GVEPAbout />} />
                    <Route path="/proteorisk/about" element={<ProteoRiskAbout />} />
                    <Route path="/mobileapp/about" element={<MobileAppAbout />} />
                    <Route path="/oa" element={<MobileAppAbout />} />
                    <Route path="/hpaagent" element={<MobileAppAbout />} />

                    <Route path="/report/:uuid" element={<ReportView />} />
                    <Route path="/set-password" element={<SetPassword />} />
                    <Route path="/activate" element={<ExternalRedirect to={KIT_ACTIVATION_URL} />} />
                    <Route path="/active" element={<ExternalRedirect to={KIT_ACTIVATION_URL} />} />

                    <Route path="/omics" element={<OmicAtlas />} />
                    <Route path="/monad" element={<Monad />} />
                    <Route path="/meeting/:session_uuid" element={<Meeting />} />

                    {/* Protected routes */}
                    <Route path="/dashboard" element={
                        <ProtectedRoute>
                            <Dashboard />
                        </ProtectedRoute>
                    } />
                    <Route path="/filetransfer1" element={
                        <ProtectedRoute>
                            <Filetransfer />
                        </ProtectedRoute>
                    } />
                    <Route path="/translate/:lang" element={<Translate />} />
                    <Route path="/ScanEx" element={<Scanner />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    {/* Add any other protected routes here */}
                </Routes>
            </Router>
        </UserProvider>
    );
}

const ProtectedRoute = ({ children }) => {
    const { user, isLoadingUser } = useUser();
    const token = Cookies.get('token');

    // Wait if user data is still loading
    if (isLoadingUser) {
        // Optionally, return a loading spinner here instead of null
        return null;
    }

    // Check both user state from context and token cookie after loading is complete
    if (!user || !token) {
        console.log('[ProtectedRoute] Redirecting to login. User state exists:', !!user, 'Token exists:', !!token);
        return <Navigate to="/login" />;
    }

    return children;
};

export default App;
